import { render, staticRenderFns } from "./StudentCourseList.vue?vue&type=template&id=04599f69"
import script from "./StudentCourseList.vue?vue&type=script&lang=js"
export * from "./StudentCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04599f69')) {
      api.createRecord('04599f69', component.options)
    } else {
      api.reload('04599f69', component.options)
    }
    module.hot.accept("./StudentCourseList.vue?vue&type=template&id=04599f69", function () {
      api.rerender('04599f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/manytomany/StudentCourseList.vue"
export default component.exports